import React from "react";
import { Container, Typography, Box, Paper } from "@mui/material";
import PublicLayout from "../components/PublicLayout";

const Impressum: React.FC = () => {
  return (
    <PublicLayout>
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Paper sx={{ p: 4 }}>
          <Typography variant="h3" gutterBottom fontWeight="bold">
            Impressum
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
            Legal Notice
          </Typography>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" gutterBottom fontWeight="bold">
              Information according to § 5 TMG
            </Typography>
            <Typography variant="body1" paragraph>
              StPadel UG (haftungsbeschränkt) i.G.
            </Typography>
            <Typography variant="body1" paragraph>
              Address: 70597, Stuttgart
              <br />
              Germany
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" gutterBottom fontWeight="bold">
              Contact
            </Typography>
            <Typography variant="body1" paragraph>
              Email:{" "}
              <a href="mailto:stuttgartpadel@gmail.com">
                stuttgartpadel@gmail.com
              </a>
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" gutterBottom fontWeight="bold">
              Responsible for Content
            </Typography>
            <Typography variant="body1" paragraph>
              According to § 55 Abs. 2 RStV:
              <br />
              StPadel UG (haftungsbeschränkt) i.G.
              <br />
              70597, Stuttgart
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" gutterBottom fontWeight="bold">
              Disclaimer
            </Typography>
            <Typography variant="subtitle1" gutterBottom fontWeight="bold">
              Liability for Content
            </Typography>
            <Typography variant="body2" paragraph>
              The contents of our pages have been created with the utmost care.
              However, we cannot guarantee the contents' accuracy, completeness,
              or topicality. According to § 7, para. 1 of the TMG
              (Telemediengesetz - German Telemedia Act), we are liable for our
              own content on these pages. However, we are not obligated to
              monitor transmitted or stored third-party information or
              investigate circumstances indicating illegal activity.
            </Typography>

            <Typography variant="subtitle1" gutterBottom fontWeight="bold">
              Liability for Links
            </Typography>
            <Typography variant="body2" paragraph>
              Our offer contains links to external third-party websites over
              whose content we have no influence. Therefore, we cannot accept
              any liability for this third-party content. The respective
              provider or operator of the pages is always responsible for the
              content of the linked pages.
            </Typography>

            <Typography variant="subtitle1" gutterBottom fontWeight="bold">
              Copyright
            </Typography>
            <Typography variant="body2" paragraph>
              The content and works on these pages created by the site operators
              are subject to German copyright law. Duplication, processing,
              distribution, and any kind of exploitation outside the limits of
              copyright law require the written consent of the respective author
              or creator.
            </Typography>
          </Box>
        </Paper>
      </Container>
    </PublicLayout>
  );
};

export default Impressum;
